import { LEAD_IMPRESSION_FIELD_NAMES, VIEW_ITEM_SENDFROM_FILTERS } from 'Constants/tracking';
import { CTA_TYPE } from 'Constants/chat';
import { isEmpty } from 'Helpers/objects';
import { LISTING_BODY_TYPE } from 'Constants/listing';

/**
 * @function isButtonVisible
 * @description Function to check if the button is visible to the user or not
 * @param {String} fieldName
 * @param {boolean} showCall
 * @param {boolean} showSeePhoneNumber
 * @param {boolean} showChat
 * @param {boolean} showInterest
 * @param {boolean} showTestDrive
 * @returns {boolean}
 */
export const isButtonVisible = (fieldName, showCall, showSeePhoneNumber, showChat, showInterest, showTestDrive) => {
    switch (fieldName) {
        case LEAD_IMPRESSION_FIELD_NAMES.PHONE:
            return showCall || showSeePhoneNumber;
        case LEAD_IMPRESSION_FIELD_NAMES.CHAT:
            return showChat;
        case LEAD_IMPRESSION_FIELD_NAMES.I_AM_INTERESTED:
            return showInterest;
        case LEAD_IMPRESSION_FIELD_NAMES.TEST_DRIVE:
            return showTestDrive;
    }
    return false;
};

/**
 * @function isIntentButtonsVisible
 * @description Function to check if the Intent button is visible to the user or not
 * @param {String} fieldName
 * @param {boolean} ctaBtns
 * @param {boolean} showCall
 * @param {boolean} showChat
 * @param {boolean} features
 * @param {boolean} showReserve
 * @param {Object} reserveFetchingData
 * @param {boolean} showChatCallIVR
 * @returns {boolean}
 */
export const isIntentButtonsVisible = (fieldName, ctaBtns, showCall, showChat, features, showReserve, reserveFetchingData, showChatCallIVR) => {
    const ctaObjLength = Object.keys(ctaBtns).length;
    const isGetStartedDisplayed = (showChatCallIVR && ctaObjLength === 2) || ctaObjLength > 2;
    const isReserveDataFetched = !showReserve || reserveFetchingData.isSuccess || reserveFetchingData.isError;

    switch (fieldName) {
        case LEAD_IMPRESSION_FIELD_NAMES.PHONE:
            return showCall;
        case LEAD_IMPRESSION_FIELD_NAMES.CHAT:
            return showChat;
        case LEAD_IMPRESSION_FIELD_NAMES.GET_STARTED:
            return isReserveDataFetched && isGetStartedDisplayed;
        case LEAD_IMPRESSION_FIELD_NAMES.I_AM_INTERESTED:
            return isReserveDataFetched && !isGetStartedDisplayed && !isEmpty(ctaBtns[CTA_TYPE.INTERESTED]);
        case LEAD_IMPRESSION_FIELD_NAMES.TEST_DRIVE:
            return isReserveDataFetched && !isGetStartedDisplayed && !isEmpty(ctaBtns[CTA_TYPE.TEST_DRIVE]);
        case LEAD_IMPRESSION_FIELD_NAMES.RESERVE:
            return !isEmpty(features.feature_flags) && !isGetStartedDisplayed && !isEmpty(ctaBtns[CTA_TYPE.RESERVE]);
        case LEAD_IMPRESSION_FIELD_NAMES.NOTIFY_ME:
            return !isEmpty(features.feature_flags) && !isGetStartedDisplayed && !isEmpty(ctaBtns[CTA_TYPE.NOTIFY]);
    }
    return false;
};

export const getSelectFromFilter = listingBodyType => {
    if (listingBodyType === LISTING_BODY_TYPE.RELAXED) {
        return VIEW_ITEM_SENDFROM_FILTERS.RELAXED;
    }
    else if (listingBodyType === LISTING_BODY_TYPE.MAIN) {
        return VIEW_ITEM_SENDFROM_FILTERS.MAIN;
    }
    return undefined;
};
